import { render, staticRenderFns } from "./EnquiryForm.vue?vue&type=template&id=5270678a&"
import script from "./EnquiryForm.vue?vue&type=script&lang=ts&"
export * from "./EnquiryForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports